import TrackerList from 'common/pages/tracker/TrackerList.tsx'

export const TrackerListAgency = (props) => <TrackerList {...props} agency/>